import { Injectable } from '@angular/core';
import { BaseService } from '../core';
import { UmmaPick } from '../dto';

@Injectable({
  providedIn: 'root',
})
export class UmmaPickService extends BaseService {
  getUmmaPicks() {
    return super.get<UmmaPick[]>('/umma-pick');
  }
}
